export type PackingSlipStatusResponse = Array<PackingSlip>;

export enum PackingSlipState {
    NEW = 'new',
    PENDING_BACKORDER = 'pending_backorder',
    PENDING_PICK = 'pending_pick',
    READY_PICK = 'ready_pick',
    PROCESSING = 'processing',
    PENDING_ACTION = 'pending_action',
    PICKED = 'picked',
    SHIPPED = 'shipped',
}

export interface PackingSlip {
    '@id': string;
    '@type': string;
    id: number;
    items: Item[];
    shipment: Shipment;
    tracks: Track[];
    state: PackingSlipState;
    createdAt: Date;
    updatedAt: Date;
    barcodeText: string;
}

export interface Item {
    '@id': string;
    '@type': string;
    id: number;
    state: string;
    description: string;
    qty: number;
    qtyPicked: number;
    qtyShipped: number;
    qtyCanceled: number;
    shippable: Shippable;
    shippableSubject: ShippSubject;
    identifier: Identifier;
    createdAt: Date;
    updatedAt: Date;
}

export interface Identifier {
    '@type': string;
    '@id': string;
    value: string;
}

export interface Shippable {
    '@id': string;
    '@type': string;
    sku: string;
    image: string;
    id: number;
    name: string;
    length: number;
    width: number;
    height: number;
    weight: number;
    special: boolean;
    imageUrl: string;
}

export interface ShippSubject {
    '@id': string;
    '@type': string;
    id: number;
    state: string;
    identifier?: Identifier;
    reference?: string;
}

export interface Shipment {
    '@id': string;
    '@type': string;
    id: number;
    state: string;
    shippingSubject: ShippSubject;
    deliveryDate?: string;
    shippingDate?: string;
    createdAt: Date;
    updatedAt: Date;
    barcodeText: string;
}

export enum TrackTraceStatus {
    PACKED = 'PACKED',
    SHIPPED = 'SHIPPED',

    IN_TRANSIT = 'IN_TRANSIT',
    IN_SORTING = 'IN_SORTING',

    PICKUP_POINT = 'PICKUP_POINT',

    ATTEMPT_DELAYED = 'ATTEMPT_DELAYED',
    ATTEMPT_NOT_AT_HOME = 'ATTEMPT_NOT_AT_HOME',

    AT_PICKUP_POINT = 'AT_PICKUP_POINT',

    COLLECTED_AT_PICKUP_POINT = 'COLLECTED_AT_PICKUP_POINT',
    DELIVERED_AT_NEIGHBOURS = 'DELIVERED_AT_NEIGHBOURS',
    DELIVERED = 'DELIVERED',

    RETURNED = 'RETURNED',
    DAMAGED = 'DAMAGED',
    REFUSED = 'REFUSED',

    ERROR = 'ERROR',
    FAILED = 'FAILED',
    OTHER = 'OTHER',
}

export interface Track {
    '@type': string;
    '@id': string;
    id: number;
    status: TrackTraceStatus;
    trackTraceCode: string | null;
    trackTraceUrl: string | null;
}
